/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";
import checkout from "layouts/pages/users/new-user/schemas/form";

const {
  formField: { email, status, jabatan, bidang, pangkat, instansi },
} = checkout;

const validations = [
  Yup.object().shape({
    [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  }),
  Yup.object().shape({
    [jabatan.name]: Yup.string().required(jabatan.errorMsg),
    [bidang.name]: Yup.string().required(bidang.errorMsg),
    [status.name]: Yup.string().required(status.errorMsg),
    [pangkat.name]: Yup.string().required(pangkat.errorMsg),
    [instansi.name]: Yup.string().required(instansi.errorMsg),
  }),
];

export default validations;
